<template>
  <div>
    <div class="profile-container">
      <div class="profile-container-header">
        <header class="title-dashboard">
          <div class="max-w-sm w-full lg:max-w-full lg:flex">
            <div
              class="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal"
            >
              <div class="flex items-center">
                <img
                  v-if="activeUserInfo.photoURL"
                  key="onlineImg"
                  :src="activeUserInfo.photoURL"
                  alt="user-img"
                />
                <div class="text-m" style="margin: 0 0 0 30px">
                  <!-- <div class="icon-container">
									<a href="">
										<i class="">
											<svg style="width:24px;height:24px" viewBox="0 0 24 24">
												<path fill="currentColor" d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
											</svg>
										</i>
									</a>
								</div> -->
                  <h5>Name:</h5>
                  <p class="text-gray-900 leading-none">{{ name }}</p>
                  <br />
                  <h5>Mail:</h5>
                  <p class="text-gray-600">{{ mail }}</p>
                </div>
              </div>
            </div>
          </div>
          <article class="title-dashboard-right">
            <slot name="button-right"></slot>
          </article>
        </header>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: localStorage.getItem("name"),
      mail: localStorage.getItem("mail"),
    };
  },
  mounted() {},
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {},
}
</script>

<style></style>
